import * as React from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';

import { GetCashRegisterRepoType, IGetCashRegisterRepo } from '../../repos';

export const useCashRegistersTableContext = () => {
  const getCashRegisterOperationsRepo = useService<IGetCashRegisterRepo>(GetCashRegisterRepoType);

  const onFetch = React.useCallback(
    async (params: TableFetchParams) => {
      const result = await getCashRegisterOperationsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        throw new Error(result.response);
      }
    },
    [getCashRegisterOperationsRepo],
  );

  return { onFetch };
};
